export default __webpack_public_path__ + "static/media/thumbnail.c5e8cab3.png";